import MiniQ2PrevS from "./MiniQ2PrevS";
import MiniQ2PrevM from "./MiniQ2PrevM";

const MiniQ2Prev = ({item, t}) => {
    const TYPES = {
        "s": t("standalone"),
        "m": t("multiple"),
    }
    const SENSORS = {
        0: "A",
        1: "B",
        2: "AB"
    }
    return <>
        <div className="preview-item">
            <div className="row">
                <div className="col-6">
                    <label>{t("type")}</label>
                    <div className="preview-input">{TYPES[item.type]}</div>
                </div>
                <div className="col-6">
                    <label>{t("confsens")}</label>
                    <div className="preview-input">{SENSORS[item.values.confsens]}</div>
                </div>
            </div>
        </div>
        {
            item.type === "s"
                ? <MiniQ2PrevS item={item} t={t}/>
                : <MiniQ2PrevM item={item} t={t}/>
        }

    </>
}
export default MiniQ2Prev